import {TeamModel} from '../../../libs/shared/core/src/models/api/teamModel';

export function computeTeamSortByName(team: TeamModel) {
  // Sandbox should always appear in last position.
  return [team.isSandbox, team.name.toLowerCase()];
}
